//CHANGE NAME TO CONTENT PREVIEW

import React from 'react'
import '../styles/header.css'
import Header from './Header'
import SubHeader from './SubHeader'
import IconHeader from './IconHeader'

class ToggleNewTest extends React.Component {
    
    constructor(props) {
        super(props)
        this.toggle = this.toggle.bind(this)
        this.toggleContent = this.toggleContent.bind(this)
        this.state = {
            showContent: false
        }
    }
    
    toggle(event) {
        event.preventDefault()
        alert('clicked!')
    } 
    
    toggleContent(event) {
        event.preventDefault()
        this.setState({
            showContent: !this.state.showContent
        })
    }
    
    render() {
        
        const {showContent} = this.state;   
        
        return(
    
            <div class={this.props.divClass}>
                
                <div class="row">
                    
                    <div class="container containerWidth">
                        
                        <IconHeader styles="leftHeader clickableHeader iconHeader inline" iconStyle="inline size" img={this.props.icon} title={this.props.name}  id={this.props.name.toLowerCase()}/>
                        
                        {/*<SubHeader styles="header leftHeader clickableHeader pointer" title={this.props.name}/>*/}
                        {/*<h3 class="header leftHeader clickableHeader pointer">{this.props.name}</h3>*/}
                            
                        <div dangerouslySetInnerHTML={{ __html: this.props.preview }} />
            
                        <p class="standardText clickableHeader pointer" onClick={this.toggleContent}>{this.props.toggle}</p>
                        
                        {showContent === true ? <div>
                                 
                            <div class="toggleContent">
                                 
                                <div dangerouslySetInnerHTML={{ __html: this.props.data }} />
                                 
                            </div>

                        </div> : ""}             
                        
                    </div>
                    
                </div>

            </div>
        );
        
    }
}
    
export default ToggleNewTest


// headerPadding
//<IconHeader styles="header leftHeader clickableHeader pointer inline" iconStyle="inline size" img={this.props.icon} title={this.props.name}/>
